<template>
    <div class="p-3 p-md-0 pt-5 pt-md-0">
        <div id='app'>
            <div id='container'>
                <div class="form-group mb-2 d-flex justify-content-end">
                    <button type="button" class="import-btn ml-2" @click="back()">Back</button>
                </div>
                <div class="row align-items-end">
                    <div class="col-md-7">
                        <div class="form-group mb-3 d-block d-sm-flex align-items-center col-gap-1">
                            <input type="text" placeholder="Enter ICal URL here" class="data-input mx-0 mt-3 mt-sm-0"
                                v-model="icalUrl" style="width: 70%;" />
                            <button class="import-btn mt-3 mt-sm-0 ml-2 ml-sm-0" @click="importIcal">Import</button>
                        </div>
                    </div>
                    <div class="col-md-5">
                        <div class="form-group mb-3 justify-content-end col-gap-1">
                            <input type="text" placeholder="ICal Link for this property" class="data-input mx-0"
                                v-model="exporturl" style="width: 100%;" />
                            <button class="import-btn" @click="exportical">Export</button> 
                        </div>
                    </div>
                </div>
                <ejs-schedule ref="scheduleObj" height="520px" :selectedDate='selectedDate'
                    :eventSettings='eventSettings' :currentView='currentView'>
                    <e-views>
                        <e-view option="Day"></e-view>
                        <e-view option="Week"></e-view>
                        <e-view option="WorkWeek"></e-view>
                        <e-view option="Month"></e-view>
                        <e-view option="Agenda"></e-view>
                    </e-views>
                </ejs-schedule>
            </div>
        </div>
    </div>
</template>
<script>
import { ScheduleComponent, ViewDirective, ViewsDirective, Day, Week, WorkWeek, Month, Agenda, Resize, DragAndDrop, ICalendarExport, ICalendarImport } from "@syncfusion/ej2-vue-schedule";
import { UploaderComponent } from '@syncfusion/ej2-vue-inputs';
import { ButtonComponent } from "@syncfusion/ej2-vue-buttons";
import { scheduleData } from './datasource.js';
import API from '../api'

export default {
    name: "App",
    components: {
        // "ejs-uploader": UploaderComponent,
        "ejs-schedule": ScheduleComponent,
        "e-views": ViewsDirective,
        "e-view": ViewDirective
    },
    data: function () {
        return {
            eventSettings: { dataSource: scheduleData },
            selectedDate: new Date(),
            currentView: 'Month',
            cssClass: 'calendar-import',
            multiple: false,
            extensions: '.ics',
            buttons: {
                browse: 'Choose file',
            },
            showFileList: false,
            icalUrl: '',
            exporturl: '',
            manualOption: '',
            selectedOption: '',
            sitename: '',
        }
    },
    provide: {
        schedule: [Day, Week, WorkWeek, Month, Agenda, Resize, DragAndDrop, ICalendarExport, ICalendarImport]
    },
    mounted() {
        this.Autoimport();
        this.exportical();
    },
    methods: {
        back() {
            this.$router.push({ name: 'properties' });
        },
        onSelect: function (args) {
            let scheduleObj = this.$refs.scheduleObj.ej2Instances;
            scheduleObj.importICalendar(args.event.target.files[0]);
        },
        exportical() {
            API.exportcalander(this.$route.params.id, data => {
                this.exporturl = data.data.url;
            }, error => {
                console.log(error);
            });

        },
        // onClick: function () {
        //     let scheduleObj = this.$refs.scheduleObj.ej2Instances;
        //     scheduleObj.exportToICalendar();
        // },
        async Autoimport(param1) {
            const scheduleObj = this.$refs.scheduleObj?.ej2Instances;
            const params = {
                Property_id: this.$route.params.id,
            };

            if (scheduleObj) {
                API.geticaldata(params, data => {
                    // console.log(data);
                    scheduleObj.importICalendar(data);
                }, error => {
                    console.log(error);
                });


                if (!param1) {
                    API.bookingdetails(params, data => {
                        // console.log(data);
                        scheduleObj.importICalendar(data);
                    }, error => {
                        console.log(error);
                    });
                }
            }
        },
        importIcal() {
            if (!this.icalUrl) {
                alert('Please enter a valid URL.');
                return;
            }
            const params = { url: this.icalUrl, propertyid: this.$route.params.id, site: 'ICal' };
            API.saveicalfile(params, data => {
                this.eventSettings.dataSource = [];
                this.Autoimport('yes');
            }, error => {
                console.error(error);
            });
        },
    }
}
</script>
<style>
.calendar-import.e-upload {
    border: 0;
    padding-left: 0 !important;
}
select.form-control {
    height: 41px;
    border-radius: 5px;   
}
.calendar-import.e-upload .e-file-select-wrap {
    padding: 0
}

.calendar-import.e-upload .e-file-select-wrap .e-file-drop {
    display: none;
}

.e-file-select-wrap {
    margin-left: 20%;
}

.form-group {
    display: flex;
    /* Aligns input and button in a row */
    align-items: center;
    /* Vertically centers the items */
    margin-bottom: 10px;
    /* Spacing below the container */
}

.data-input {
    padding: 10px;
    border: 1px solid #ccc !important;
    border-radius: 5px;
    margin-right: 10px;
    font-size: 16px;
}

.data-input:focus {
    border-color: #007bff;
    outline: none;
}

.import-btn {
    background-color: #007bff;
    color: white;
    border: none;
    border-radius: 5px;
    padding: 10px 15px;
    cursor: pointer;
    font-size: 16px;
    min-width: 90px;
}

.import-btn:hover {
    background-color: #0056b3;
}
</style>